<template>
  <div class="my-profile container">
    <div class="leftbar-nav">
      <div
          :class="['menu-item', isIncludesPath(item.path) ? 'active-menu-item' : '']"
          v-for="item in getMenuData"
          :key="item.meta.title"
          @click="handleSelect(item)"
      >
        <div>{{ item.meta.title }}</div>
        <div>{{ item.meta.titleEn }}</div>
      </div>
    </div>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
export default {
  name: "my-profile",
  components: {},
  data() {
    return {
      activePath: "",
    };
  },
  props: {},
  computed: {
    getMenuData() {
      let data = this.$_.cloneDeep(this.$router.options.routes.find((item) => item.name == "myProfile").children[0].children).filter(v => !v.hidden);
      return data.map((item) => {
        item.path = `/my-profile/${item.path}`;
        return item;
      });
    },
  },
  async mounted() {
    this.activePath = this.$route.path;
  },
  methods: {
    isIncludesPath(path) {
      return this.activePath.indexOf(path) > -1;
    },
    handleSelect(item) {
      this.activePath = item.path;
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-profile {
  display: flex;
}

.leftbar-nav {
  width: 120px;
  flex: none;
  position: sticky;
  position: -webkit-sticky;
  top: 109px;

  .menu-item {
    cursor: pointer;
    color: rgba(51, 51, 51, 0.4);
    text-align: center;
    margin-top: 25px;

    &:hover {
      font-weight: bold;
      color: #333333;
    }

    &.active-menu-item {
      font-weight: bold;
      color: #333333;
    }
  }

  .logo-box {
    margin-right: 60px;
    cursor: pointer;

    img {
      width: 156px;
    }
  }

  .login-content {
    cursor: pointer;
    margin-left: auto;

    a {
      font-size: 15px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 84px;
    }
  }
}

main {
  flex: 1;
  padding-left: 20px;
}
</style>
